<template>
  <div class="tsc-chart-wrapper">
    <div id="TradeCommissionChart" class="chart"></div>
    <div class="table-wrap">
      <div class="table-content" :style="{ gridTemplateColumns: gridLeftCss + ' 1fr' }">
        <table class="label-table">
          <tbody>
            <tr v-for="row in tableRows" :key="row.label">
              <td class="label">{{ row.label }}</td>
            </tr>
          </tbody>
        </table>
        <div class="values-container" :style="{ paddingRight: gridRightCss }">
          <table class="values-table">
            <tbody>
              <tr v-for="row in tableRows" :key="row.label">
                <td v-for="(val, idx) in row.data" :key="idx" class="value">{{ val }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { tradeStatsCommissionChart } from '@/api/trade_stat_commission'
import * as echarts from 'echarts'
import { numberFormatW } from '@/utils/utils'

export default {
  name: 'TSCChart',
  props: {
    search: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      data: {},
      gridLeft: 120,
      gridRight: 50
    }
  },
  computed: {
    months() {
      const arr = []
      for (let i = 1; i <= 12; i++) {
        arr.push(i + '月')
      }
      return arr
    },
    tableRows() {
      const formatMoney = (v) => numberFormatW(Number(v || 0), 2)
      const formatPercent = (v) => `${Number(v || 0).toFixed(2)}%`
      return [
        { label: '退货前机构GMV', data: (this.data.gmv_return_bef || []).map(formatMoney) },
        { label: '退货后机构GMV', data: (this.data.gmv_return_aft || []).map(formatMoney) },
        { label: '退货前总佣金', data: (this.data.ci_return_bef || []).map(formatMoney) },
        { label: '退货后总佣金', data: (this.data.ci_return_aft || []).map(formatMoney) },
        { label: '退货率', data: (this.data.rate_return || []).map(formatPercent) },
        { label: '退货前佣金率', data: (this.data.rate_return_bef || []).map(formatPercent) },
        { label: '退货后佣金率', data: (this.data.rate_return_aft || []).map(formatPercent) }
      ]
    },
    gridLeftCss() {
      return this.gridLeft + 'px'
    },
    gridRightCss() {
      return this.gridRight + 'px'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init: async function() {
      this.loading = true
      this.data = await tradeStatsCommissionChart(this.search)
      this.loading = false
      this.$emit('update:stat', this.data.stat || {})
      this.drawerChart()
    },
    getSeries: function() {
      const colors = [
        { main: '#ff80a4', other: '#ffd4e2' },
        { main: '#75a7ff', other: '#b6cfff' },
        { main: '#ffb980', other: '#ffe5d4' },
        { main: '#75ff80', other: '#b6ffd4' }
      ]
      const map = [
        {
          name: '退货前机构GMV',
          data: this.data.gmv_return_bef,
          type: 'bar'
        },
        {
          name: '退货后机构GMV',
          data: this.data.gmv_return_aft,
          type: 'bar'
        },
        {
          name: '退货前总佣金',
          data: this.data.ci_return_bef,
          type: 'bar'
        },
        {
          name: '退货后总佣金',
          data: this.data.ci_return_aft,
          type: 'bar'
        },
        {
          name: '退货率',
          data: this.data.rate_return,
          type: 'line',
          yAxisIndex: 1
        },
        {
          name: '退货前佣金率',
          data: this.data.rate_return_bef,
          type: 'line',
          yAxisIndex: 1
        },
        {
          name: '退货后佣金率',
          data: this.data.rate_return_aft,
          type: 'line',
          yAxisIndex: 1
        }
      ]
      map.map((item, i) => {
        if (item.type === 'bar') {
          item.barWidth = '15%'
          item.seriesLayoutBy = 'row'
          item.itemStyle = {
            barBorderRadius: [30, 30, 0, 0],
            color: {
              x: 0,
              y: 0,
              x2: 1,
              y2: 1,
              colorStops: [
                { offset: 0, color: colors[i % 4].main },
                { offset: 1, color: colors[i % 4].other }
              ]
            }
          }
        } else {
          item.symbolSize = 1
          item.symbol = 'circle'
          item.smooth = true
          item.lineStyle = {
            width: 2
          }
          item.itemStyle = {
            barBorderRadius: [30, 30, 0, 0],
            color: {
              x: 0,
              y: 0,
              x2: 1,
              y2: 1,
              colorStops: [
                { offset: 0, color: colors[i % 4].main },
                { offset: 1, color: colors[i % 4].main }
              ]
            }
          }
        }
      })
      return map
    },
    drawerChart() {
      const _this = this
      const dom = document.getElementById('TradeCommissionChart')
      const myChart = echarts.init(dom, null, {
        renderer: 'canvas',
        useDirtyRect: false
      })
      myChart.setOption({
        grid: {
          left: this.gridLeft,
          right: this.gridRight,
          top: 40,
          bottom: 20
        },
        legend: {
          // right: '4%',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#666'
            }
          },
          formatter: function(params) {
            let result = params[0].axisValue + '<br/>'
            params.forEach(param => {
              let value = param.value
              if (param.seriesName.includes('率')) {
                // 百分比格式化
                value = Number(value).toFixed(2) + '%'
              } else {
                // 金额格式化
                value = numberFormatW(Number(value), 2)
              }
              result += param.marker + param.seriesName + ': ' + value + '<br/>'
            })
            return result
          }
        },
        xAxis: {
          type: 'category',
          data: this.months
        },
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#666',
              formatter(value) {
                return numberFormatW(value, 2)
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#666',
                type: 'dashed',
                opacity: 0.1
              }
            }
          },
          {
            type: 'value',
            position: 'right',
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#666',
              formatter(value) {
                return value + '%'
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: _this.getSeries()
      })
    }
  }
}
</script>


<style scoped>
.tsc-chart-wrapper {
  width: 100%;
}

.chart {
  width: 100%;
  height: 360px;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
  margin-top: 10px;
}

.label-table,
.values-table {
  border-collapse: collapse;
}

.label-table td,
.values-table td {
  border: 1px solid #ebeef5;
  padding: 6px 8px;
  font-size: 12px;
  color: #606266;
}

.label-table td.label {
  white-space: nowrap;
  text-align: left;
}

.values-table td.value {
  text-align: right;
}

.table-content {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
}

.values-container {
  overflow: hidden;
  box-sizing: border-box;
}

.values-table {
  width: 100%;
  table-layout: fixed;
}
</style>
